// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const golduck: PokeData = {
  "id": 55,
  "name": "golduck",
  "height": 17,
  "weight": 766,
  "base_experience": 175,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "tail-whip",
    "disable",
    "water-gun",
    "hydro-pump",
    "surf",
    "psybeam",
    "confusion",
    "hypnosis",
    "screech",
    "amnesia",
    "bubble",
    "fury-swipes",
    "encore",
    "psych-up",
    "yawn",
    "water-sport",
    "water-pulse",
    "me-first",
    "aqua-tail",
    "zen-headbutt",
    "aqua-jet",
    "wonder-room",
    "soak"
  ],
  "moves": [
    "scratch",
    "hydro-pump",
    "bubble",
    "aqua-tail",
    "zen-headbutt",
    "aqua-jet",
    "rain-dance",
    "liquidation",
    "water-spout",
    "brine",
    "aqua-cutter",
    "whirlpool",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 23,
    "item": null,
    "species": [
      {
        "name": "psyduck",
        "order": 59,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "golduck",
        "order": 60,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 54,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 123,
    "speed": 131,
    "ability_power": 146
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
